// Copyright (c) 2022 by Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { Identifier, IRelatedService, PickerCallback, Related } from '../../../contexts'
import { logger } from '../../../support'

import { FormAddBtn } from '../FormAddBtn'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
@Component<RelatedPartial<unknown>>({
  components: { FormAddBtn },
  created () {
    if (this.isRelatedSet) {
      this.describeRelated()
      this.resolveRelated()
    }
  }
})
export class RelatedPartial<Data> extends Vue {
  @Prop({ type: Function, required: false })
  public readonly pickRelated!: PickerCallback

  @Prop({ type: Object, required: true })
  protected readonly relatedService!: IRelatedService

  @Prop({ type: Boolean, required: false, default: true })
  protected readonly showControls!: boolean

  /**
   * Resolved related
   */
  public resolved: Data | null = null

  /**
   * Description of passed-in related
   */
  public described: Data | null = null

  /**
   * Checks where related is set
   */
  public get isRelatedSet (): boolean {
    return false
  }

  /**
   * State of related (resolved/unresolved)
   */
  public get isRelatedResolved (): boolean {
    return this.resolved !== null
  }

  /**
   * Describes related
   */
  protected describeRelated (siteId?: Identifier): void {
    const relatedSource = this.getRelatedSource()

    if (typeof relatedSource === 'undefined') {
      logger('[RelatedPartial]: [relatedSource] is [undefined]!', 'error')
      return
    }

    const result = this.relatedService.describe<Data>(relatedSource, siteId)

    if (result instanceof Promise) {
      result.then(content => { this.described = content })
    } else {
      this.described = result
    }
  }

  protected resolveRelated (siteId?: Identifier): void {
    const relatedSource = this.getRelatedSource()

    if (typeof relatedSource === 'undefined') {
      logger('[RelatedPartial]: [relatedSource] is [undefined]!', 'error')
      return
    }

    this.relatedService.resolve<Data>(relatedSource, undefined, siteId).then((content) => {
      this.resolved = content
    })
  }

  protected getRelatedSource (): Related | undefined {
    throw new Error('[RelatedPartial]: There\'s no implementation of [getRelatedSource] method!')
  }
}
